import PhoneScreenshot from './PhoneScreenshot'

/** CleanDock dashboard — shown on the hero stage. */
const HomeScreen = () => (
  <PhoneScreenshot src="/LandingPhoneMock/Dash.PNG" alt="CleanDock dashboard" />
)

export default HomeScreen
